module.exports = __webpack_public_path__ + "static/media/qb-icon.cae62872.svg";